// extracted by mini-css-extract-plugin
export var completionBody = "_ju-2";
export var completionCard = "_ju-0";
export var completionFooter = "_ju-3";
export var completionTitle = "_ju-1";